var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import { componentsButton, buttonList } from "./collection-hotkeys-button";
var CollectionExecutionModule = namespace("collection-execution");
import { Prop } from 'vue-property-decorator';
var CollectionHotkey = /** @class */ (function (_super) {
    __extends(CollectionHotkey, _super);
    function CollectionHotkey() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showHotKey = false;
        return _this;
    }
    Object.defineProperty(CollectionHotkey.prototype, "buttonLists", {
        get: function () {
            var _this = this;
            return buttonList.filter(function (v) { return !v.auth.length || v.auth.includes(_this.menuChannel); });
        },
        enumerable: false,
        configurable: true
    });
    CollectionHotkey.prototype.isShowHotkey = function () {
        var _a, _b;
        this.showHotKey = !this.showHotKey;
        if (this.showHotKey && ((_a = document.getElementById("container-content-phone")) === null || _a === void 0 ? void 0 : _a.style.display) !== "none") {
            (_b = document.getElementById("icon-doyan-phone")) === null || _b === void 0 ? void 0 : _b.click();
        }
    };
    __decorate([
        CollectionExecutionModule.State
    ], CollectionHotkey.prototype, "menuChannel", void 0);
    __decorate([
        Prop()
    ], CollectionHotkey.prototype, "carFrameNo", void 0);
    CollectionHotkey = __decorate([
        Component({
            components: __assign({}, componentsButton)
        })
    ], CollectionHotkey);
    return CollectionHotkey;
}(Vue));
export default CollectionHotkey;
